import { useContext, useEffect, useState } from "react";

import { IamAuthContext } from "@megaron/auth-react";

export const useGoogleSheetsAccessToken = (enabled: boolean) => {
  const [token, setToken] = useState<string>();

  const auth = useContext(IamAuthContext);

  useEffect(() => {
    if (!enabled) return;
    if (token) return;
    const user = auth.getGoogleUser();
    (async () => {
      if (!user?.getGrantedScopes().includes("https://www.googleapis.com/auth/spreadsheets"))
        user?.grant({
          scope: "https://www.googleapis.com/auth/spreadsheets",
        });

      const accessToken = user?.getAuthResponse().access_token;

      setToken(accessToken);
    })();
  }, [enabled, token, auth]);

  return token;
};
